import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent} from '@angular/material/dialog';
import {Opportunity} from '../../interfaces/opportunity.interface';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {MatFormField, MatInput} from '@angular/material/input';
import {MatButton} from '@angular/material/button';



@Component({
    imports: [
        MatFormField,
        ReactiveFormsModule,
        MatDialogClose,
        MatButton,
        MatDialogActions,
        MatInput,
        MatDialogContent
    ],
    template: `
        <div mat-dialog-content style="display: flex; flex-direction: column; gap: 15px">
            <span>Choose a new name for the opportunity.</span>
            <mat-form-field>
                <input matInput [formControl]="nameControl" required/>
            </mat-form-field>
        </div>
        <div mat-dialog-actions style="display: flex; justify-content: space-between">
            <button mat-flat-button [mat-dialog-close]="null">Cancel</button>

            <button mat-flat-button color="primary" [mat-dialog-close]="nameControl.value.trim()"
                    [disabled]="nameControl.invalid">
                Confirm
            </button>
        </div>
    `
})
export class OpportunityChangeNameDialogComponent {
    nameControl: UntypedFormControl;

    constructor(
        @Inject(MAT_DIALOG_DATA) public opportunity: Opportunity
    ) {
        this.nameControl = new UntypedFormControl(this.opportunity.opportunityName);
    }
}